// Warm the code-split chunks on hover so navigation feels instant after login.
// Calling import() here reuses the exact same webpack chunk lazyLoad() requests.
export const prefetchAdmin = () => {
  import("@/pages/admin/AdminLayout");
  import("@/pages/admin/AdminDashboard");
};

export const prefetchOwner = () => {
  import("@/pages/owner/OwnerDashboard");
};

export const prefetchBooking = () => {
  import("@/pages/Booking");
};
